export const alternaCorGuia = ((id) => {
    setTimeout(() => {
        document.querySelector('[referencia="'+id+'"]').classList.add('flash-tab')
        setTimeout(() => {
            document.querySelector('[referencia="'+id+'"]').classList.remove('flash-tab')
        }, 500)
    }, 10)
})

export const isMobile = () => {
    const deviceAgent = navigator.userAgent.toLowerCase()
    return deviceAgent.match(/(iphone|ipod|ipad|android)/)
}

export const ativaBarraRolagem = (id, modal = null) => {
    setTimeout(() => {
        let elemento
        if(modal){
            const div = document.getElementById(modal)
            elemento = div.querySelector('#' + id)
        }else{
            elemento = document.getElementById(id)
        }
        if(elemento){
            elemento.scrollIntoView()
            let posicao = elemento.getBoundingClientRect()
            window.scrollTo(
                {
                    left: posicao.left,
                    top: posicao.top + window.scrollY - 10,
                    behavior: 'smooth'
                }
            )
        }
    }, 300)
}